// Of een aanmelding op deze activiteit nog ergens heen gewijzigd kan worden: er
// is een tijdslot met een echte plek (niet vol, geen pauze) dat niet botst met
// een eigen boeking. Een wachtlijstplek telt niet: wijzigen verplaatst naar een
// plek, niet naar een wachtlijst.
//
// De botsing is dezelfde die de wijzigwizard blokkeert ("Je bent al aangemeld
// ... op dit tijdstip"). Zonder die check telde het eigen tijdslot als
// alternatief, en opende "Wijzigen" een wizard zonder keuze (ClickUp 1240cced42j).
//
// `holdsSlot(date, slot, specialist, location)` zegt of de gebruiker op dat
// tijdstip al geboekt staat; de activiteitpagina geeft daar functions.checkDate
// voor mee. De wijzigwizard kijkt ook naar specialist en locatie: verplaatst een
// werkgever andermans boeking, dan is diens eigen tijdslot geen alternatief
// (ClickUp 1240ccedj0x).
export function hasSlotToChangeTo(activity, holdsSlot) {
  return (activity?.locations ?? []).some((location) =>
    (location.specialists ?? []).some((specialist) =>
      (specialist.dates ?? []).some((dateObject) =>
        (dateObject.slots ?? []).some(
          (slot) =>
            slot.spots > 0 &&
            slot.type != "break" &&
            !slot.is_full &&
            !holdsSlot(dateObject.date, slot, specialist, location),
        ),
      ),
    ),
  );
}
